export const COLORS = {
  color1: '#079664' /* Primary Dark */,
  color2: '#16B965' /* Primary Default */,
  color3: '#43D188' /* Primary Medium */,
  color4: '#81E7B2' /* Primary Light */,
  color5: '#FFFFFF' /* White */,
  color6: '#202020' /*  Black */,
  color7: '#BCBBBB' /* Medium (Gray)*/,
  color8: '#F6F6F6' /* Extra Light ( Extra Light Gray) */,
  color9: '#797979' /* Dark (Dark Gray)*/,
  color10: '#E1E1E1' /* Light (Light Gray)*/,
  color11: '#4C883A' /* Green5*/,
  color12: '#FF4F61' /* Red */,
  color13: '#7DBC6A' /* Green */,
  color14: '#CCEFDD' /* Primary Extra light */,

  chartColor1: '#079664',
  chartColor2: '#16B965',
  chartColor3: '#43D188',
  chartColor4: '#81E7B2',
  chartColor5: '#CCEFDD',
};
